import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

interface CollapsePanel {
  title: string;
  content?: string;
}

@Component({
  selector: 'umkt-collapse-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './collapse-panel.component.html',
  styleUrls: ['./collapse-panel.component.scss'],
})
export class CollapsePanelComponent implements OnInit {
  @Input() panels: CollapsePanel[] = [];
  @Input() defaultOpen: number = -1;
  @Input() leftIconClass?: string;

  openedIndex: number = -1;

  ngOnInit() {
    if (this.defaultOpen >= 0 && this.defaultOpen < this.panels.length) {
      this.openedIndex = this.defaultOpen;
    }
  }

  togglePanel(index: number) {
    this.openedIndex = this.openedIndex === index ? -1 : index;
  }

  isPanelOpen(index: number): boolean {
    return this.openedIndex === index;
  }
}
